// src/App.jsx
// アプリのエントリ。認証状態のみここで保持し、ルーティングは routes/AppRoutes.jsx に分離。
// レイアウト・サイドバー・トップバー・メニュー定義は層ごとに別ファイル:
//   - layout/Layout.jsx       : Sidebar + Topbar + main の枠
//   - layout/Sidebar.jsx      : 左サイドバー
//   - layout/Topbar.jsx       : 上部バー
//   - auth/RequireAuth.jsx    : 認証ガード
//   - config/menu.js          : サイドバーのメニュー定義とロール/機能フラグでのフィルタ
//   - config/roles.js         : ロール表示ラベル & カラー
//   - routes/AppRoutes.jsx    : ルーティング

import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './routes/AppRoutes';
import './App.css';

export default function App() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }

    fetch('/api/user/me', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(data => {
        if (data.success) setUser(data.user);
        else localStorage.removeItem('token');
      })
      .catch(() => localStorage.removeItem('token'))
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const handleUserUpdate = (updatedUser) => {
    setUser(prev => ({ ...prev, ...updatedUser }));
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div style={{ color: '#888', fontSize: '1rem' }}>読み込み中...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AppRoutes
        user={user}
        onLogin={handleLogin}
        onLogout={handleLogout}
        onUserUpdate={handleUserUpdate}
      />
    </BrowserRouter>
  );
}
